import { Button } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as GoogleLogo } from 'src/images/svgs/brands/google-full-color.svg';
export const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: linear-gradient(to bottom, rgba(249, 249, 251, 0) 0%, rgba(249, 249, 251, 1) 20.4%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0px 32px 0px;
  z-index: 100;
  pointer-events: none;
`;
export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  max-width: 800px;
  padding: 0 24px;
`;
export const StyledTextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
export const StyledHeading = styled.h2`
  font-family: ${({
  theme
}) => theme.fonts.familyUbuntu};
  font-weight: ${({
  theme
}) => theme.fonts.weight.semiBold};
  font-size: 2.4rem;
  line-height: 1.149;
  text-align: center;
  color: rgba(21, 28, 43, 1);
  margin: 0;
`;
export const StyledDescription = styled.p`
  font-family: ${({
  theme
}) => theme.fonts.familySansPro};
  font-weight: 400;
  font-size: 16px;
  line-height: 1.257;
  text-align: center;
  color: #525a6a;
  margin: 0;
`;
export const StyledButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  max-width: 300px;

  p {
    pointer-events: all;
  }
`;
export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
export const StyledFullWidthButton = styled(Button)`
  width: 100%;
`;
export const StyledFullWidthLink = styled(Link)`
  width: 100%;
  text-decoration: none;
`;
export const StyledGoogleLogo = styled(GoogleLogo)`
  && {
    width: 1.6rem;
    height: 1.6rem;
  }
`;
export const StyledLoginLink = styled(Link)`
  color: ${({
  theme
}) => theme.colors.info.main};
  text-decoration: none;
  :hover,
  :focus {
    text-decoration: underline;
  }
`;